import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Nabvar from "./Navbar";
import Footer from "./footer";
import MyLanding from "./Cards";
import { FaUserTie } from "react-icons/fa";
import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";
import { basicauthblog } from "../Utils/Credentials";
const Blog = () => {
  const [postdata, setpostdata] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = basicauthblog;
  const base64Credentials =
    typeof window === "undefined"
      ? Buffer.from(`${username}:${password}`).toString("base64")
      : btoa(`${username}:${password}`);
  const Getproductblogs = async () => {
    setTransactionLoaderState(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          product_name: "billpunch",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetProductBlogs`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        setpostdata(data.data || []);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    Getproductblogs();
  }, []);
  return (
    <>
      <Nabvar />
      <div className="row">
        <div className="col-1"></div>
        <div className="col-10">
          <div className="row " style={{ overflow: "hidden", height: "auto" }}>
            <div
              className=" col-12 m-0 p-0 "
              style={{ marginRight: "2rem" }}
            >
              <div className="" style={{ marginRight: "2rem" }}>
              <MyLanding />
              </div>
            </div>

            {/* <div className="col-md-3 col-12 p-md-0 p-5 ">
              <div className="d-flex flex-column justify-content-start align-items-center mt-5 ">
                <h6
                  style={{
                    fontFamily: "Roboto, sans-serif",
                    fontWeight: "500",
                  }}
                >
                  Related Tags
                </h6>
              </div>

              <div
                className="d-flex flex-column justify-content-start align-items-center mt-4"
                style={{
                  maxHeight: "80vh",
                  overflowY: "scroll",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <style>
                  {`
      div::-webkit-scrollbar {
        display: none;
      }
    `}
                </style>

                {[...postdata].map((blog) => (
                  <div
                    key={blog.post_id}
                    className="d-flex align-items-center mb-3 w-100 px-3"
                    style={{ textAlign: "start", maxWidth: "600px" }}
                  >
                    <img
                      src={blog.post_featured_image}
                      alt="Author"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        flexShrink: 0,
                        marginRight: "1rem",
                      }}
                    />
                    <Link
                      to={`/blog/${blog.post_slug}`}
                      onClick={() => {
                        console.log("click hua");
                        sessionStorage.setItem("Slug", JSON.stringify(blog));
                      }}
                      style={{ textDecoration: "none", flexGrow: 1 }}
                    >
                      <div className="d-flex flex-column">
                        <p
                          style={{
                            fontSize: ".8rem",
                            margin: 0,
                            color: "black",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {blog.post_title}
                        </p>
                        <p
                          style={{
                            fontSize: ".8rem",
                            color: "#686D76",
                            margin: 0,
                            fontWeight: "600",
                          }}
                        >
                          <FaUserTie
                            style={{ fontSize: ".9rem", color: "grey" }}
                          />
                          &nbsp; {blog.post_author}
                        </p>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </div>
        <div className="col-1"></div>
      </div>

      <Footer />
    </>
  );
};

export default Blog;
